import { Form, Select } from 'antd';
import { CompWithFormProp } from '../../constants/constants';
import { supGroups } from '../../constants/sup';
import { selectHerePlaceholder } from '../../constants/translations';

export const SupGroupSelector = ({ form }: CompWithFormProp) => {
  const selectedGrade = Form.useWatch(
    ['registration', 'selectedSubject'],
    form,
  );

  return (
    <Form.Item
      label="SUP grupė"
      name={['registration', 'supGroup']}
      style={{ display: selectedGrade ? 'block' : 'none' }}
    >
      <Select placeholder={selectHerePlaceholder} showSearch={true}>
        {supGroups.map((item, index) => (
          <Select.Option key={`selector_item_${index + 1}`} value={item}>
            {item}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
